import { useFeatureAccess } from "../context/FeatureAccessContext";
import { isFeatureUnlocked } from "../lib/featureAccess";
import LockedFeatureCard from "./LockedFeatureCard";

/**
 * Wrap a route element. Shows the real component if the user has access,
 * otherwise renders a LockedFeatureCard for the slug.
 */
export default function FeatureGate({ slug, children }) {
  const { access, loading } = useFeatureAccess();
  if (loading || !access) return children; // optimistic: don't flash lock
  if (isFeatureUnlocked(access, slug)) return children;
  return <LockedFeatureCard slug={slug} />;
}
